export const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV;



// WEBPACK FOOTER //
// ./src/settings/env.js